import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => (
  <div
    className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
    style={{ backgroundColor: '#f7f9fc' }}
  >
    <motion.div
      initial={false}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
    >
      <p
        className="text-8xl font-bold mb-4"
        style={{
          background: 'linear-gradient(135deg, #1c587a 0%, #2980b9 50%, #1c587a 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        404
      </p>
      <h1 className="text-2xl font-bold mb-3" style={{ color: '#2c3e50' }}>Page Not Found</h1>
      <p className="text-base mb-8 max-w-sm" style={{ color: '#6c757d' }}>
        The page you're looking for doesn't exist. Let's get you back on track.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-semibold rounded-full transition-all duration-200 hover:-translate-y-0.5"
          style={{ padding: '12px 28px', backgroundColor: '#1c587a', color: '#fff', boxShadow: '0 4px 20px rgba(28,88,122,0.25)' }}
        >
          Back to Home
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 font-semibold rounded-full transition-all duration-200"
          style={{ padding: '12px 28px', color: '#1c587a', border: '1.5px solid rgba(28,88,122,0.3)' }}
        >
          Contact Us
        </Link>
      </div>
    </motion.div>
  </div>
);

export default NotFound;
